import React from 'react';
import Select from 'react-select';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { t } from '../../../modules/infra/i18n';

import supportedLanguages from './supportedLanguages';
import Option from './Option';
import MultiValue from './MultiValue';
import ValueContainer from './ValueContainer';

const DEFAULT_LANGUAGE = 'en';

const LanguageMultiSelect = (props) => {
  const onChange = (value, { action, option }) => {
    // even option is disabled react-select still allow deselect this option using keyboard buttons
    const isTryingToRemoveDisabledOption =
      action === 'deselect-option' && props.isOptionDisabled && props.isOptionDisabled(option);

    if (isTryingToRemoveDisabledOption) {
      return;
    }

    props.input.onChange(value);
  };

  // https://github.com/redux-form/redux-form/issues/2768
  const onBlur = () => props.input.onBlur(undefined);

  return (
    <Select
      isMulti
      isClearable={false}
      backspaceRemovesValue={false}
      hideSelectedOptions={false}
      isSearchable={false}
      options={props.options}
      isOptionDisabled={props.isOptionDisabled}
      defaultValue={[]}
      components={{ Option, MultiValue, ValueContainer }}
      className={classnames('c-language-multi-select', props.className)}
      classNamePrefix="c-language-multi-select"
      placeholder={props.placeholder || t('settings:language_multiselect.placeholder')}
      value={props.input.value}
      onChange={onChange}
      onFocus={props.input.onFocus}
      onBlur={onBlur}
    />
  );
};

LanguageMultiSelect.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  options: PropTypes.array,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  isOptionDisabled: PropTypes.func,
  input: PropTypes.object.isRequired,
};

LanguageMultiSelect.defaultProps = {
  options: supportedLanguages,
  className: '',
  placeholder: undefined,
  isOptionDisabled: ({ value }) => value === DEFAULT_LANGUAGE,
};

const LanguageMultiSelectComponent = LanguageMultiSelect;

export default LanguageMultiSelectComponent;
